// extracted by mini-css-extract-plugin
export default {"list":"CustomImage_list__M3z+b","gallery":"CustomImage_gallery__sx6-9"};